import { MenuItem } from '@/types';

const nyRoutes: MenuItem[] = [
  {
    path: '/products',
    name: '产品列表',
    element: '../views/Products/pages/Index',
  },
  {
    path: '/product-center/products',
    name: '产品管理',
    element: '../views/Products/pages/Index',
  },
  {
    path: '/contracts',
    name: '合同管理',
    element: '../views/Ny/pages/Contracts',
  },
  {
    path: '/customers',
    name: '客户管理',
    element: '../views/Ny/pages/Customers',
  },
  {
    path: '/fp',
    name: '融资规划',
    element: '../views/Ny/pages/Fp',
  },
  {
    path: '/operations/dashboard',
    name: '运营工作台',
    element: '../views/Ny/pages/OperationsDashboard',
  },
  {
    path: '/sp-dashboard',
    name: '服务商工作台',
    element: '../views/Ny/pages/OperationsDashboard',
  },
  {
    path: '/notifications',
    name: '消息通知',
    element: '../views/Ny/pages/Notifications',
  },
  {
    path: '/ny-dashboard',
    name: '运营工作台',
    element: '../views/Ny/pages/OperationsDashboard',
  },
  {
    path: '/members',
    name: '成员管理',
    element: '../views/Ny/pages/NyStaff',
  },
  {
    path: '/ratings',
    name: '评价监控',
    element: '../views/Ny/pages/Ratings',
  },
  {
    path: '/operations/ratings',
    name: '评价监控',
    element: '../views/Ny/pages/Ratings',
  },
  {
    path: '/questionnaires',
    name: '问卷中心',
    element: '../views/Ny/pages/Questionnaires',
  },
  {
    path: '/leadpool',
    name: '待员工分配',
    element: '../views/Ny/pages/Leadpool',
  },
  {
    path: '/sp-orders',
    name: '服务单监控',
    element: '../views/Ny/pages/SpServiceOrderMonitor',
  },
  {
    path: '/dispatch',
    name: '分配规则',
    element: '../views/Ny/pages/NyDispatch',
  },
  {
    path: '/lead-supervise/dispatch-rule',
    name: '分配规则',
    element: '../views/Ny/pages/NyDispatch',
  },
  {
    path: '/ny-dispatch',
    name: '分配规则',
    element: '../views/Ny/pages/NyDispatch',
  },
  {
    path: '/all-leads',
    name: '全员线索',
    element: '../views/Ny/pages/AllLeads',
  },
  {
    path: '/my-leads',
    name: '我的线索',
    element: '../views/Ny/pages/MyLeads',
  },
  {
    path: '/ny-all-leads',
    name: '服务单中心',
    element: '../views/Ny/pages/NYAllLeads',
  },
  {
    path: '/lead-supervise/all-leads',
    name: '服务单中心',
    element: '../views/Ny/pages/NYAllLeads',
  },
  {
    path: '/service-dispatch',
    name: '分配调度',
    element: '../views/Ny/pages/ServiceDispatch',
  },
  {
    path: '/sla-monitor',
    name: 'SLA 监督',
    element: '../views/Ny/pages/NYSlaMonitor',
  },
  {
    path: '/sp-deadlines',
    name: '时效监控',
    element: '../views/Ny/pages/NYSlaMonitor',
  },
  {
    path: '/lead-dispatch',
    name: '线索分配',
    element: '../views/Ny/pages/LeadDispatch',
  },
  {
    path: '/leads_approval',
    name: '线索分配审批',
    element: '../views/Ny/pages/LeadsApproval',
  },
  {
    path: '/approval',
    name: '审批管理',
    element: '../views/Ny/pages/Approval',
  },
  {
    path: '/approval_config',
    name: '审批流程配置',
    element: '../views/Ny/pages/ApprovalConfig',
  },
  {
    path: '/manage-center/approval-config',
    name: '审批流程配置',
    element: '../views/Ny/pages/ApprovalConfig',
  },
  {
    path: '/sp_manage',
    name: '服务商管理',
    element: '../views/Ny/pages/SpManageModule',
  },
  {
    path: '/operations/service-provider',
    name: '服务商管理',
    element: '../views/Ny/pages/SpManageModule',
  },
  {
    path: '/roles',
    name: '角色权限',
    element: '../views/Ny/pages/Roles',
  },
  {
    path: '/tenant/role',
    name: '角色权限',
    element: '../views/Ny/pages/Roles',
  },
  {
    path: '/parks',
    name: '园区管理',
    element: '../views/Ny/pages/Parks',
  },
  {
    path: '/basic-data/parks',
    name: '园区管理',
    element: '../views/Ny/pages/Parks',
  },
  {
    path: '/basic-data/eqx',
    name: '易企秀管理',
    element: '../views/Ny/pages/EqxManage',
  },
  {
    path: '/rules',
    name: '规则配置',
    element: '../views/Ny/pages/NYRules',
  },
  {
    path: '/settlement',
    name: '分账管理',
    element: '../views/Ny/pages/Settlement',
  },
  {
    path: '/settlement/:id',
    name: '分账详情',
    element: '../views/Ny/pages/SettlementDetail',
  },
  {
    path: '/ny-report',
    name: '报表',
    element: '../views/Ny/pages/NyReport',
  },
  {
    path: '/tenants',
    name: '租户管理',
    element: '../views/Ny/pages/Users',
  },
  {
    path: '/tenant/member',
    name: '成员管理',
    element: '../views/Ny/pages/NyStaff',
  },
  {
    path: '/query-tools',
    name: '查询工具',
    element: '../views/Search/pages/Index',
  },
];

export default nyRoutes;
